import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaInformation from './media-information-model'
import {
  CreateMediaInformationAsync,
  DeleteMediaInformationAsync,
  LoadMediaInformationsAsync,
} from './mediaInformation-thunk'
const initialState: mediaInformationSliceState = {
  mediaInformation: [],
  selected_mediaInformation: '',
  is_loading_mediaInformation: false,
  is_creating_mediaInformation: false,
  is_deleting_mediaInformation: false,
}
export interface mediaInformationSliceState {
  mediaInformation: MediaInformation[]
  selected_mediaInformation?: string
  is_loading_mediaInformation: boolean
  is_creating_mediaInformation: boolean
  is_deleting_mediaInformation: boolean
}
export const mediaInformationSlice = createSlice({
  name: 'mediaInformation',
  initialState,
  reducers: {
    setSelectedmediaInformation: (state, action) => {
      state.selected_mediaInformation = action.payload
    },
    clearStatemediaInformation: (state) => {
      state.mediaInformation = []
      state.is_loading_mediaInformation = false
      state.is_creating_mediaInformation = false
      state.is_deleting_mediaInformation = false
    },
    mergemediaInformation: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaInformation = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaInformation = merge(state.mediaInformation, payload) as any
        }
      }
    },

    add_mediaInformation: (state, action) => {
      if (action.payload) {
        state.mediaInformation = [...state.mediaInformation, action.payload]
      }
    },
    set_mediaInformation: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaInformation = state.mediaInformation.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaInformationsAsync.pending, (state) => {
      state.is_loading_mediaInformation = true
    })
    builder.addCase(LoadMediaInformationsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaInformation = false
      if (action.payload) {
        state.mediaInformation = action.payload
      }
    })
    builder.addCase(LoadMediaInformationsAsync.rejected, (state) => {
      state.is_loading_mediaInformation = false
    })
    builder.addCase(CreateMediaInformationAsync.pending, (state) => {
      state.is_creating_mediaInformation = true
    })
    builder.addCase(CreateMediaInformationAsync.fulfilled, (state) => {
      state.is_creating_mediaInformation = false
    })
    builder.addCase(CreateMediaInformationAsync.rejected, (state) => {
      state.is_creating_mediaInformation = false
    })
    builder.addCase(DeleteMediaInformationAsync.pending, (state) => {
      state.is_deleting_mediaInformation = true
    })
    builder.addCase(DeleteMediaInformationAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaInformation = false
      if (state.mediaInformation) {
        state.mediaInformation = state.mediaInformation.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaInformationAsync.rejected, (state) => {
      state.is_deleting_mediaInformation = false
    })
  },
})

export const {
  clearStatemediaInformation,
  setSelectedmediaInformation,
  set_mediaInformation,
  mergemediaInformation,
  add_mediaInformation,
} = mediaInformationSlice.actions

export const get_mediaInformation =
  (id?: string) =>
  (state: {
    mediaInformation: {
      mediaInformation: MediaInformation[]
    }
  }): MediaInformation | null => {
    let temp = state?.mediaInformation?.mediaInformation?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediaInformation?.mediaInformation[0] || null
  }
export const get_selected_mediaInformation = (state: {
  mediaInformation: mediaInformationSliceState
}): MediaInformation | null => {
  let id = state?.mediaInformation?.selected_mediaInformation
  let temp = state?.mediaInformation?.mediaInformation?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaInformation = (state: {
  mediaInformation: {
    mediaInformation: MediaInformation[]
  }
}): MediaInformation[] => {
  let temp = state?.mediaInformation?.mediaInformation
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaInformation_busy = (state: {
  mediaInformation: mediaInformationSliceState
}) => {
  return (
    state?.mediaInformation.is_deleting_mediaInformation ||
    state?.mediaInformation.is_loading_mediaInformation ||
    state?.mediaInformation.is_creating_mediaInformation
  )
}
export const is_deleting_mediaInformation_busy = (state: {
  mediaInformation: mediaInformationSliceState
}) => {
  return state?.mediaInformation.is_deleting_mediaInformation
}
export const is_loading_mediaInformation_busy = (state: {
  mediaInformation: mediaInformationSliceState
}) => {
  return state?.mediaInformation.is_loading_mediaInformation
}
export const is_creating_mediaInformation_busy = (state: {
  mediaInformation: mediaInformationSliceState
}) => {
  return state?.mediaInformation.is_creating_mediaInformation
}

export default mediaInformationSlice.reducer
